import {FC} from 'react';
import {MY_TAX_FNS_PENDING_DESCRIPTION, MY_TAX_FNS_PENDING_TITLE} from '../../model';
import {FnsPendingEnvelopeIcon} from 'shared/assets/icons';
import {StepLayout} from 'features/registration';
import styles from './MyTaxFnsPendingStep.module.css';

export const MyTaxFnsPendingStep: FC = () => {
	return (
		<StepLayout variant="fill">
			<StepLayout.Intro title={MY_TAX_FNS_PENDING_TITLE} subtitle={MY_TAX_FNS_PENDING_DESCRIPTION} />

			<StepLayout.Content className={styles.illustration}>
				<FnsPendingEnvelopeIcon className={styles.illustrationIcon} />
			</StepLayout.Content>
		</StepLayout>
	);
};
